import React from 'react';

const Warning = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="20"
    viewBox="0 0 22 20"
    {...props}
  >
    <path
      d="M22 1.467v12.718c0 .81-.672 1.467-1.5 1.467h-9.687c-.066 0-.13.026-.177.072l-3.781 3.698c-.143.14-.358.182-.545.106-.186-.076-.308-.254-.308-.452v-3.18c0-.134-.112-.244-.25-.244H1.5c-.828 0-1.5-.657-1.5-1.467V1.467C0 .657.672 0 1.5 0h19c.828 0 1.5.657 1.5 1.467zM9.626 11.765c.029.712.644 1.276 1.396 1.278h.024c.363-.005.709-.15.959-.4s.383-.585.37-.93c-.029-.713-.645-1.277-1.397-1.278h-.024c-.363.006-.709.15-.958.4-.25.25-.383.586-.37.93zM11 1.957c-.57 0-1.031.438-1.031.978v5.217c0 .54.461.978 1.031.978.57 0 1.031-.438 1.031-.978V2.935c0-.54-.461-.978-1.031-.978z"
      transform="translate(0 2)"
    />
  </svg>
);

export default Warning;
